export default __webpack_public_path__ + "static/media/809.2ef22f5e.png";